import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Slider from "react-slick";
const images = require.context("../assets/images", false);

function Services() {

const [slidesToShow, setSlidesToShow] = useState(3);

  useEffect(() => {
    const updateSlides = () => {
      const width = window.innerWidth;
      if (width < 768) {
        setSlidesToShow(1);
      } else if (width < 992) {
        setSlidesToShow(2);
      } else {
        setSlidesToShow(3);
      }
    };

    updateSlides(); // run immediately

    window.addEventListener("resize", updateSlides);
    return () => window.removeEventListener("resize", updateSlides);
  }, []);


const NextArrow = ({ onClick }) => {
    return (
      <button className="custom-next next1 slick-arrow" onClick={onClick}>
        <img src={images("./Forward.svg")} alt="next arrow" />
      </button>
    );
  };

  // ✅ Custom Prev Arrow
  const PrevArrow = ({ onClick }) => {
    return (
      <button className="custom-prev prev1 slick-arrow" onClick={onClick}>
        <img src={images("./backward.svg")} alt="prev arrow" />
      </button>
    );
  };

 const settings = {
  dots: true,
  infinite: true,
  slidesToShow: slidesToShow,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 2000,
  speed: 500,
  arrows: true,
  adaptiveHeight: true,
  nextArrow: <NextArrow />,
  prevArrow: <PrevArrow />
};


const tours = [
  {
    id: 1,
    title: "Golden Triangle - Short Tour",
    image: images("./Golden-Traingle-shortTour-India.jpg"),
    location: "Delhi, Agra, Jaipur",
    duration: "3 Nights / 4 Days",
    bookLink: "/golden-triangle-short-tour/#enquire",
    detailsLink: "/golden-triangle-short-tour/"
  },
  {
    id: 2,
    title: "Golden Triangle - Standard Tour",
    image: images("./goldentrianglestandardtour.jpg"),
    location: "Delhi, Agra, Jaipur",
    duration: "6 Nights / 7 Days",
    bookLink: "/golden-triangle-standard-tour/#enquire",
    detailsLink: "/golden-triangle-standard-tour/"
  },
  {
    id: 3,
    title: "Golden Triangle - Oberoi Hotels",
    image: images("./oberoihotel.jpg"),
    location: "Delhi, Agra, Jaipur",
    duration: "6 Nights / 7 Days",
    bookLink: "/golden-triangle-oberoi-hotels/#enquire",
    detailsLink: "/golden-triangle-oberoi-hotels/"
  },
  {
    id: 4,
    title: "Golden Triangle & Tiger Tour",
    image: images("./Golden-Triangle-Tiger-Tour.jpg"),
    location: "Delhi, Agra, Jaipur, Ranthambhore National Park",
    duration: "8 Nights / 9 Days",
    bookLink: "/golden-triangle-tiger-tour/#enquire",
    detailsLink: "/golden-triangle-tiger-tour/"
  },
  {
    id: 5,
    title: "Best of India Tour",
    image: images("./aboutus_tour.webp"),
    location: "Delhi, Agra, Jaipur, Rawla Narlai, Udaipur + Extension",
    duration: "9-14 Nights / 10-15 Days",
    bookLink: "/best-luxury-private-india-tour/#enquire",
    detailsLink: "/best-luxury-private-india-tour/"
  }
];



  return (
    <div className="services mt-5">
          <img className="top-right-position" src={images("./dance-girl.svg")} />
        <img className="bottom-left-position" src={images("./tiger.svg")} />
        <div className="inner-services green-dot-bg paddingY-70">
      <div className="container">
        <div className="heading center">
            <h2>Golden Triangle Tour Packages</h2>
            <p>Something Amazing Waiting For you</p>
        </div>

        <div className="row align-items-center">

      {/* LEFT SIDE SLIDER */}
      <div className="col-md-9">
        <div className="service-slider position-relative">

          <Slider {...settings} className="my-slider">

            {tours.map((tour) => (
              <div key={tour.id}>
                <div className="service-slider-card">

                  <Link to={tour.detailsLink}><img src={tour.image} alt={tour.title} /></Link>
                  <Link to={tour.detailsLink}><h3 className="mb-4">{tour.title}</h3></Link>
<div className="sectionheight">
                  <p>
                    <img src={images("./map-marker.svg")} alt="location" />
                    {" "}{tour.location}
                  </p>

                  <p>
                    <img src={images("./clock.svg")} alt="duration" />
                    {" "}{tour.duration}
                  </p>
</div>
                  <div className="btns-group mt-4">
                    <Link to={tour.bookLink} className="grey-btn">Book Now</Link>
                    <Link to={tour.detailsLink} className="grey-btn">Details</Link>
                  </div>

                </div>
              </div>
            ))}

          </Slider>

        </div>
      </div>

      {/* RIGHT SIDE CARD */}
      <div className="col-md-3">
        <div className="tailor-made-card color-white">
          <Link to="/luxury-golden-triangle-enquiry">Tailor Made Tour</Link>
          <p className="center">
            If you are not into brochure tours and looking for something
            especially customized as per your preferences and travel style,
            our team will do that for you happily.
          </p>
        </div>
      </div>

    </div>
    <div className="service-btn-list mt-80">
        <Link to="/5-star-luxury-hotels" className="secondary-btn">
          LUXURY HOTELS LIST <img src={images("./arrow-right-btn.svg")} alt="arrow right" />
        </Link>
        <Link to="/car-details" className="secondary-btn">
          CAR DETAILS <img src={images("./arrow-right-btn.svg")} alt="arrow right" />
        </Link>
        <Link to="/golden-triangle-tour-extensions" className="secondary-btn">
          TOUR EXTENSIONS <img src={images("./arrow-right-btn.svg")} alt="arrow right" />
        </Link>
        <Link to="/authentic-indian-experiences" className="secondary-btn">
          AUTHENTIC EXPERIENCES <img src={images("./arrow-right-btn.svg")} alt="arrow right" />
        </Link>
      </div>
      </div>
    </div>
    </div>
  );
}

export default Services;